import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

export default function NameDialog({
  open,
  title,
  label,
  initialValue = '',
  onClose,
  onSubmit,
  validate,
}) {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setValue(initialValue);
      setError('');
    }
  }, [initialValue, open]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationError = validate?.(value) || '';

    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      onSubmit(value);
      onClose();
    } catch (submitError) {
      setError(submitError.message || 'Unable to save this name.');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <form id="name-dialog-form" onSubmit={handleSubmit}>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            label={label}
            value={value}
            error={Boolean(error)}
            helperText={error || ' '}
            onChange={(event) => {
              setValue(event.target.value);
              if (error) {
                setError('');
              }
            }}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" form="name-dialog-form" variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
